import { registerResetFn } from '@/store/reset';
import { create } from 'zustand';

import { type StepProps } from '../types';

export interface HelpWizardStore {
  steps: StepProps[];
  isDialogOpen: boolean;
}

const initialState: HelpWizardStore = {
  steps: [],
  isDialogOpen: false,
};

export const useHelpWizardStore = create<HelpWizardStore>()(() => ({ ...initialState }));

registerResetFn(() => useHelpWizardStore.setState(initialState));
